export const SITE = {
  brand: "Aima Health",
  practitioner: "Lara Brown",
  tagline: "Holistic hormone health for women who are tired of being dismissed.",
  email: "lara@aimawomenshealth.com",
  instagram: "https://instagram.com/aima.women",
  calendlyUrl: "https://calendly.com/aimawomenshealth/freecall",
  logoSage: "/brand/aima-rect-transparent.png",
  logoWhite: "/brand/aima-logo-white.png",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/work-with-me", label: "Work With Me" },
  { to: "/for-parents", label: "For Parents" },
  { to: "/retreats", label: "Retreats" },
  { to: "/articles", label: "Articles" },
  { to: "/contact", label: "Contact" },
];

export const YOUTUBE = {
  introVideoId: "ER2MeWIQIDg",
  introUrl: "https://youtu.be/ER2MeWIQIDg",
};

export const SERVICES = [
  {
    slug: "pcos",
    title: "PCOS & PMOS",
    summary:
      "Move beyond the pill and metformin. We identify your unique PCOS / PMOS driver - insulin, inflammation, adrenal or post-pill - and address it at the root.",
    points: ["Insulin & blood sugar work", "Inflammation mapping", "Cycle restoration"],
  },
  {
    slug: "pms-acne",
    title: "PMS, Acne & Cycle Confusion",
    summary:
      "Whether you're a teenager or an adult, if you have hormonal acne, cyclical anxiety, painful or absent periods, this isn't normal, and together we can solve it.",
    points: ["Estrogen metabolism", "Liver & gut support", "Skin-from-within protocols"],
  },
  {
    slug: "thyroid",
    title: "Thyroid Conditions",
    summary:
      "Hashimoto's, hypothyroid, sluggish conversion. We look beyond TSH to the full thyroid picture and the nutrients, stress and gut terrain underneath.",
    points: ["Full thyroid panels", "Nutrient repletion", "Autoimmune root work"],
  },
  {
    slug: "infertility",
    title: "Infertility",
    summary:
      "Often what's called 'infertility' is a body that hasn't been given the conditions to ovulate. Missed cycle signs, years on the pill, quiet nutrient deficiencies, under-sleep, over-stress. And before we look at any of that, up to half of cases involve sperm health. Real, resolvable causes, without immediately turning to pharmaceutical intervention.",
    points: [
      "Ovulation confirmation & cycle tracking",
      "Nutrient, stress and lifestyle foundations",
      "Male fertility considered too",
    ],
  },
  {
    slug: "perimenopause",
    title: "Perimenopause",
    summary:
      "Sleep that breaks, anxiety that ambushes, periods that surprise. The decade before menopause asks for a new kind of care, one that's listening.",
    points: ["Progesterone support", "Sleep & nervous system", "Body composition shifts"],
  },
  {
    slug: "natural-contraception",
    title: "Natural Contraception",
    summary:
      "A real alternative to chemical contraception, without the pills and synthetic hormones. Learn to track cervical fluid, basal body temperature and biomarkers, and read your cycle as your fifth vital sign.",
    points: [
      "Fertility awareness method (FAM) & body literacy",
      "BBT and cervical mucus tracking",
      "Fertility as a biomarker of health",
    ],
  },
];

export const PROGRAMS = [
  {
    slug: "discovery-call",
    name: "Discovery Call",
    price: "Complimentary · 20 min",
    description:
      "A gentle, no-pressure conversation. Tell me what's been happening, and I'll tell you honestly whether - and how - I can help.",
    includes: ["20-minute video call", "Honest fit assessment", "Next-step recommendations"],
    cta: "Book a discovery call",
    ctaHref: "https://calendly.com/aimawomenshealth/freecall",
  },
  {
    slug: "single-consult",
    name: "One Private Consultation & Health Plan",
    price: "£185 · 75 min",
    description:
      "A deep one-off session for women who need clarity, a second opinion, or a targeted protocol for a specific concern.",
    includes: ["Full intake review", "75-minute consultation", "Written protocol & summary", "2 weeks email follow-up"],
    cta: "Book a consultation",
    ctaHref: "https://pay.gocardless.com/BRT01KWYE56ABRNT0442YWCKRG8SK",
  },
  {
    slug: "rooted",
    name: "3 Month 1-1 Personal Health Support",
    price: "£795 · most popular",
    description:
      "My signature container. Three months of considered, layered work to restore cycle, energy and trust in your body.",
    includes: [
      "Initial 90-min intake",
      "Bi-weekly 45-min sessions (5 total)",
      "Personalised functional protocol",
      "Recommended lab interpretation",
      "Voice note and email support between sessions",
    ],
    cta: "Apply for 3 month support",
    ctaHref: "https://pay.gocardless.com/BRT01KWYE8AFQ6DBKR980KGWP1X14",
    featured: true,
  },
  {
    slug: "anchored",
    name: "6 Month 1-1 Personal Health Support",
    price: "£1,495",
    description:
      "For complex cases: long-standing PCOS, perimenopause, autoimmune thyroid. Six months gives us the time roots need.",
    includes: [
      "Everything in the 3-month programme",
      "12 sessions across 6 months",
      "Quarterly lab reviews",
      "Bespoke lifestyle and nutrition plan",
    ],
    cta: "Pay in full",
    ctaHref: "https://pay.gocardless.com/BRT01KWYEFZSG72AYQE781K75PJD6",
    secondaryCta: "Pay in 2 instalments",
    secondaryCtaHref: "https://pay.gocardless.com/BRT01KWYEEDJ0WZAWHVADXBKDJV1A",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "After eight years of being told my labs were 'normal', Lara was the first person to actually look at me. Six months in, my cycle is back, my skin is clear, and I trust my body again.",
    name: "Sophie K.",
    detail: "London · PCOS",
  },
  {
    quote:
      "I came to Lara exhausted and angry at a system that kept dismissing me. She listened. She believed me. And she helped me build a body that could carry me into my forties feeling alive.",
    name: "Marianne R.",
    detail: "Edinburgh · Perimenopause",
  },
  {
    quote:
      "Working with Aima Health changed how I relate to my own biology. The circadian work alone was worth every penny - I sleep, I wake, I bleed on time. I feel like myself.",
    name: "Anya P.",
    detail: "Bristol · Hashimoto's",
  },
  {
    quote:
      "Lara is the practitioner I wish every woman had access to. Calm, evidence-based, and quietly fierce on your behalf.",
    name: "Hannah D.",
    detail: "Manchester · PMS & Acne",
  },
];

export const RESOURCES = [
  {
    slug: "cycle-tracking-guide",
    title: "The Cycle Tracking & Hormone Health Guide",
    description:
      "A beautifully designed guide to reading your cycle like the language it has always been. BBT, cervical mucus, LH strips, low progesterone, and what your body is actually telling you.",
    pages: "Interactive guide",
    image: "/brand/cycle-tracking-guide.png",
  },
  {
    slug: "morning-light-protocol",
    title: "The Morning Light Protocol",
    description:
      "The simplest, most powerful intervention I give every client. A free 7-day reset to anchor your hormones to natural light.",
    pages: "7-day guide · PDF",
    image:
      "https://images.unsplash.com/photo-1773757807865-8635ef353be2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHx3b21hbiUyMHNlcmVuZSUyMG5hdHVyYWwlMjBsaWdodCUyMHdlbGxuZXNzfGVufDB8fHx8MTc3OTUxMzI1OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "perimenopause-primer",
    title: "The Perimenopause Primer",
    description:
      "The early signs, the lab markers worth asking for, and the five lifestyle anchors I recommend to every woman over 35.",
    pages: "22 pages · PDF",
    image:
      "https://images.unsplash.com/photo-1622352607117-88f6089aa418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxmZW1hbGUlMjBwcmFjdGl0aW9uZXIlMjBwb3J0cmFpdCUyMG5hdHVyYWwlMjBsaWdodCUyMHdhcm18ZW58MHx8fHwxNzc5NTEzMjU5fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const MEDIA = {
  hero: "/brand/lara-hero.webp",
  portrait: "/brand/lara-portrait.jpg",
  services:
    "https://images.unsplash.com/photo-1615227875116-ae28a77814fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxob2xpc3RpYyUyMGhlcmJhbCUyMHRlYSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3Nzk1MTMyNjB8MA&ixlib=rb-4.1.0&q=85",
  bgSoft:
    "https://static.prod-images.emergentagent.com/jobs/9075bda6-19c7-4d3d-b6ae-367b13b8e841/images/66dc402ec3f3210ee83533827fc456e2e8a1b4fc1a05eda0d0c664fa504a481f.png",
  bgSand:
    "https://static.prod-images.emergentagent.com/jobs/9075bda6-19c7-4d3d-b6ae-367b13b8e841/images/378f1413619c1a31682392c4cb83e9d5a25bd2a0f7a4f29fc5d96c3a1062c668.png",
};
